module.exports = __webpack_public_path__ + "30df24f45df9bdf48a687473f27ee259.png";